import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './filter.css';

const Filter = ({ onFilterChange, filters, selectedFilter }) => {
  const { t } = useTranslation();
  const onHandleClick = (filter) => {
    if (onFilterChange) onFilterChange(filter);
  };

  return (
    <Swiper spaceBetween={10} slidesPerView={'auto'}>
      <SwiperSlide>
        <button
          className={`button-filter ${selectedFilter === null ? 'active' : ''}`}
          onClick={() => onHandleClick(null)}
        >
          {t('all')}
        </button>
      </SwiperSlide>
      {filters.length > 0 &&
        filters.map((filter, index) => (
          <SwiperSlide key={index}>
            <button
              className={`button-filter ${selectedFilter?.id === filter.id ? 'active' : ''}`}
              onClick={() => onHandleClick(filter)}
            >
              {filter.name}
            </button>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default Filter;
